@let view = data();

<ui-headlines [data]="view.headlines" [level]="headingLevel()"></ui-headlines>

<a
  [link]="view.button.link"
  mat-stroked-button
  uiContentLink
  uiPageBlockImpression
  uiPageBlockLinkClick
>
  {{ view.button.link.label }}
</a>
